const catalogue1 = (data) => {
  const node = data.node;
  const catalogueList = node.list;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style="text-align: left;"><span style="font-size: 18.75px;font-family: Microsoft Yahei;">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "si34-Cg8nx",
        width: 434.56220472440947,
        height: 434.56220472440947,
        left: 24.400524934383203,
        top: 66.46887139107612,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "xBVqGPNKlk",
        width: 329.42624671916013,
        height: 329.42624671916013,
        left: 76.96850393700791,
        top: 119.0368503937008,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "q69_25Jcme",
        width: 297.489343832021,
        height: 113.75,
        left: 86.75648566487904,
        top: 239.99372142141067,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><span style="color: #FFFFFF;font-size: 62.5px;font-family: Microsoft Yahei;">目录</span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "Iqzww_5qOI",
        width: 253.3890813648294,
        height: 52.8125,
        left: 108.80661689847486,
        top: 206.12502624671916,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><span style="color: #FFFFFF;font-size: 21.875px;font-family: Microsoft Yahei;">contents</span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "Ov3KHuDwE6",
        width: 476.86267716535434,
        height: 224.75,
        left: 485.7750131233596,
        top: 93.75002624671916,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: htmlText,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "C4iwQz7yPS",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "tm3G_KwYgV",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "XpTCAVc06-",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hyms7MI9c9",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "KR5WGpdzO_",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "B6Ywg1DPTQ",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "m81gMfleqJ",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "S0OQuVqzJB",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "vPxghCae9a",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default catalogue1;
